


export const STATUS: { value: boolean | string; label: string }[] = [
  { value: "all", label: "All" },
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];
